module.exports = __webpack_public_path__ + "assets/hamburger-09b9ca.svg";